"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Providers = void 0;
exports.Providers = {
    Oura: "oura",
    Fitbit: "fitbit",
    Garmin: "garmin",
    Whoop: "whoop",
    Strava: "strava",
    Renpho: "renpho",
    Peloton: "peloton",
    Wahoo: "wahoo",
    Zwift: "zwift",
    FreestyleLibre: "freestyle_libre",
    FreestyleLibreBle: "freestyle_libre_ble",
    EightSleep: "eight_sleep",
    Withings: "withings",
    AppleHealthKit: "apple_health_kit",
    Manual: "manual",
    Ihealth: "ihealth",
    GoogleFit: "google_fit",
    BeurerApi: "beurer_api",
    BeurerBle: "beurer_ble",
    Omron: "omron",
    OmronBle: "omron_ble",
    OnetouchBle: "onetouch_ble",
    AccuchekBle: "accuchek_ble",
    ContourBle: "contour_ble",
    Dexcom: "dexcom",
    DexcomV3: "dexcom_v3",
    Hammerhead: "hammerhead",
    MyFitnessPal: "my_fitness_pal",
    HealthConnect: "health_connect",
    Polar: "polar",
    Cronometer: "cronometer",
    Kardia: "kardia",
    WhoopV2: "whoop_v2",
};
